export default __webpack_public_path__ + "static/media/chatBubbleIcon.85782174.svg";